import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import { SlackConnectionFieldsFragment } from './fragments';

export const SLACK_CONNECT = gql`
  mutation SlackConnect($input: SlackConnectInput!) {
    slackConnect(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...SlackConnectionFields
      }
    }
  }
  ${ErrorFragment}
  ${SlackConnectionFieldsFragment}
`;

export const SLACK_DISCONNECT = gql`
  mutation SlackDisconnect($input: SlackDisconnectInput!) {
    slackDisconnect(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;

export const SLACK_OAUTH_CALLBACK = gql`
  mutation SlackOAuthCallback($input: SlackOAuthCallbackInput!) {
    slackOAuthCallback(input: $input) {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;

export const SLACK_OAUTH_START = gql`
  mutation SlackOAuthStart {
    slackOAuthStart {
      errors {
        ...ErrorFields
      }
      entity {
        authorizeUrl
      }
    }
  }
  ${ErrorFragment}
`;

export const SLACK_UNINSTALL = gql`
  mutation SlackUninstall {
    slackUninstall {
      errors {
        ...ErrorFields
      }
      message
    }
  }
  ${ErrorFragment}
`;
